import './Menu.css';

import { withRouter } from 'react-router-dom';
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { Menu, message } from 'antd';
import i18n from 'i18next';

import { apis } from '../../api/index.js';
import audioSrc from '../../mp3/tip.mp3';
import printTip from '../../mp3/print-tip.mp3';
import timeoutTip from '../../mp3/timeout-tip.mp3';
import { changeMenuTaskFlagUpdate, aesMinEncrypt } from '../../utils';
import { formatDate } from '../../utils';

import * as tool from './tool';

const { SubMenu } = Menu;

class MenuList extends Component {
  static propTypes = {
    home: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object,
    toggleCollapsed: PropTypes.func,
    setMenuCollapsedData: PropTypes.func,
    newTaskState: PropTypes.func,
    changeMenuTaskFlag: PropTypes.string,
    newTaskStateObj: PropTypes.object,
    soundState: PropTypes.bool,
    menuCollapsed: PropTypes.bool,
    setMenuOpenList: PropTypes.func,
    menuOpenList: PropTypes.array,
    userInfo: PropTypes.object,
    //更新CT用户信息
    setCTUserInfo: PropTypes.func,
    setCurrentCTReportTime: PropTypes.func,
  };

  static defaultProps = {
    home: true,
  };

  constructor(props) {
    super(props);
    const location = this.props.history.location;
    this.state = {
      selectedKey: [location.pathname + location.search],
      collapsed: false,
      menuList: [],
      showAudio: false,
      menuOpenList: [],
    };
    this.audioModule = React.createRef();
    this.audio = '';
  }

  componentDidMount() {
    const collapsed = false;
    this.props.toggleCollapsed(!collapsed);

    const menuList = this.props.userInfo.menus || [];
    let menuOpenList = [];
    if (!this.props.menuCollapsed) {
      menuOpenList = this.props.menuOpenList;
      if (!(menuOpenList && menuOpenList.length > 0)) {
        menuOpenList = [menuList[0].childMenus[0].menuContent];
      }
    }
    this.setState({
      collapsed,
      boxWidth: collapsed ? '14%' : '6%',
      menuOpenList: menuOpenList,
    });
    let soundPlayTime = localStorage.getItem('soundPlayTime');
    soundPlayTime = soundPlayTime ? new Date(soundPlayTime) : new Date();
    const currentTime = new Date();
    const times = currentTime.getTime() - soundPlayTime.getTime();

    if (times >= 2 * 60 * 1000) this.calcTip();
    this.updateTime();
    changeMenuTaskFlagUpdate(this.updateTime);
  }
  time = () => {
    window['tipTime'] = setInterval(() => this.calcTip(), 2 * 60 * 1000);
  };
  clearAllTime = () => {
    for (var i = 0; i < window['tipTime']; i++) {
      clearInterval(window['tipTime']);
    }
  };
  updateTime = () => {
    this.clearAllTime();
    this.time();
  };
  componentDidUpdate(prevProps) {
    if (prevProps.changeMenuTaskFlag !== this.props.changeMenuTaskFlag) {
      this.updateTime();
    }
    if (prevProps.menuCollapsed !== this.props.menuCollapsed) {
      if (this.props.menuCollapsed) {
        this.setState({ menuOpenList: [] });
      } else {
        const menuList = this.props.userInfo.menus || [];
        let menuOpenList = this.props.menuOpenList;
        if (!(menuOpenList && menuOpenList.length > 0)) {
          menuOpenList = [menuList[0].childMenus[0].menuContent];
        }
        this.setState({ menuOpenList });
      }
    }
  }

  async calcTip() {
    localStorage.setItem('soundPlayTime', new Date());
    // 判断提示权限
    const { userInfo } = this.props;
    const hasPower = tool.playPower(userInfo);
    if (hasPower) {
      const { userInfo } = this.props;
      let res = await apis.taskCountTip();
      res = res.data;
      let ctRes = {};
      const audit3 = tool.calcAudit([18, 54], userInfo); //远程诊断报告CT
      if (audit3) {
        ctRes = await apis.ctTaskCountTip();
        if (ctRes.code === '0') ctRes = ctRes.data;
        else {
          const username = userInfo.accountName;
          const time = formatDate(new Date());
          const str = `${username}#${time}`;
          const token = aesMinEncrypt(str);
          const loginRes = await apis.login4CT(token);
          if (loginRes.code === '0') {
            ctRes = await apis.ctTaskCountTip();
            ctRes = ctRes.data;
          }
        }
      }

      let obj = {};
      // 有声音  菜单左边有提示---智能筛查
      obj.tubeReview = {
        tip: res.tubeReview > 0 || ctRes.tubeReview > 0,
        sound: res.tubeReview > 0 || ctRes.tubeReview > 0,
      };

      // 菜单左边有提示---Ai应用
      obj.AIReview = {
        tip: res.AIReview > 0 || ctRes.AIReview > 0,
        sound: false,
      };

      //有声音 菜单左边有提示--远程诊断报告有未打印的报告
      obj.unPrint = {
        tip: res.unPrintReport > 0 || ctRes.unPrintReport > 0,
        sound: res.unPrintReport > 0 || ctRes.unPrintReport > 0,
      };

      //有声音 菜单左边有提示--远程诊断报告有即将超时的报告
      obj.timeout = {
        tip: res.willTimeOutCnt > 0 || ctRes.willTimeOutCnt > 0,
        sound: res.willTimeOutCnt > 0 || ctRes.willTimeOutCnt > 0,
      };

      let sum1 = 0;
      res.nightReport.map(a => (sum1 += a.count));
      (ctRes.nightReport || []).map(a => (sum1 += a.count));

      // 有声音  菜单左边有提示---远程报告夜间急诊
      obj.nightReport = { tip: sum1 > 0, sound: sum1 > 0 };

      let sum2 = 0;
      res.report.map(a => (sum2 += a.count));
      (ctRes.report || []).map(a => (sum2 += a.count));

      // 菜单左边有提示---远程报告夜间急诊
      obj.report = { tip: sum2 > 0, sound: false };

      this.props.newTaskState(obj);

      this.playSound();
    }
  }

  playSound() {
    const { userInfo } = this.props;
    this.audio = document.createElement('audio'); //试试iframe
    this.audio.className = 'audioModule';
    this.audio.src = '';
    const menuObj = this.props.newTaskStateObj;

    const { nightReport, tubeReview, unPrint, timeout } = menuObj;

    const audit1 = tool.calcAudit([16, 28], userInfo); //智能筛查审核
    const audit2 = tool.calcAudit([18, 19], userInfo); //远程诊断报告
    const audit3 = tool.calcAudit([18, 54], userInfo); //远程诊断报告CT

    if (timeout && timeout.sound && (audit2 || audit3)) {
      this.audio.src = timeoutTip;
    } else if (nightReport && nightReport.sound && (audit2 || audit3)) {
      this.audio.src = audioSrc;
    } else if (tubeReview && tubeReview.sound && audit1) {
      this.audio.src = audioSrc;
    } else if (unPrint && unPrint.sound && (audit2 || audit3)) {
      this.audio.src = printTip;
    }

    this.audio.muted = true;

    const { pathname } = this.props.history.location;
    const { soundState } = this.props;
    const inPath = ['/datadark', '/register', '/login'].includes(pathname);
    const needPlay = !(pathname.includes('/report/') || inPath);

    this.audio.addEventListener(
      'canplaythrough',
      function() {
        if (soundState && needPlay) {
          this.muted = false;

          if (timeout && timeout.sound && (audit2 || audit3)) {
            this.play();
          } else if (nightReport && nightReport.sound && (audit2 || audit3)) {
            this.play();
          } else if (tubeReview && tubeReview.sound && audit1) {
            this.play();
          } else if (unPrint && unPrint.sound && (audit2 || audit3)) {
            this.play();
          }
        }
      },
      false
    );

    if (soundState && needPlay) {
      if (nightReport && nightReport.sound && (audit2 || audit3)) {
        this.audio.load();
      } else if (tubeReview && tubeReview.sound && audit1) {
        this.audio.load();
      } else if (unPrint && unPrint.sound && (audit2 || audit3)) {
        this.audio.load();
      } else if (timeout && timeout.sound && (audit2 || audit3)) {
        this.audio.load();
      }
    }
  }

  //upload:AI应用；data:数据看板；charts:统计分析
  getMenuItem = menuList => {
    const { menuCollapsed, userInfo } = this.props;
    // 判断提示权限

    let auditPower = tool.playPower(userInfo);

    return menuList.map(item => {
      if (item.childMenus.length > 0) {
        const isOpen = this.showNewSubTip(item, !menuCollapsed ? 'open' : '');
        return (
          <SubMenu
            key={item.menuContent}
            className={item.image + ' ' + isOpen}
            title={
              <span title={i18n.t(item.menuName)} className="menu-text">
                {i18n.t(item.menuName)}
              </span>
            }
          >
            {this.getMenuItem(item.childMenus)}
          </SubMenu>
        );
      }
      return (
        <Menu.Item
          key={item.menuContent}
          className={item.image}
          onClick={this.handleClick}
        >
          <span title={i18n.t(item.menuName)} className="menu-text">
            {i18n.t(item.menuName)}
          </span>
          {auditPower ? this.showNewTip(item) : null}
        </Menu.Item>
      );
    });
  };

  handleClick = event => {
    if (event.key !== this.props.history.location.pathname) {
      if (event.key === '/datadark') window.open(event.key, '_blank');
      else if (event.key.includes('http')) {
        localStorage.setItem('thirdUrl', event.key);
        this.props.history.push(`/third/platform`);
      } else if (event.key === '/report-list/ct') {
        this.login4CT(event.key);
      } else this.props.history.push(event.key);
    }
  };

  showNewTip(item) {
    const menuObj = this.props.newTaskStateObj;
    const newTipCnt = tool.getNewTipCnt(item, menuObj);
    return newTipCnt;
  }
  showNewSubTip(item, type) {
    const menuObj = this.props.newTaskStateObj;
    let subClassName = tool.getSubClassName(item, type, menuObj);
    return subClassName;
  }
  setMenuOpenList = item => {
    let openList = tool.getOpenList(item);
    if (!this.props.menuCollapsed) this.props.setMenuOpenList(openList);
    this.setState({ menuOpenList: openList });
  };
  login4CT = key => {
    const username = this.props.userInfo.accountName;
    const time = formatDate(new Date());
    const str = `${username}#${time}`;
    const token = aesMinEncrypt(str);

    apis.ctLogin4Third(token).then(res => {
      if (res.code === '0') {
        const userInfo = res.data;

        const resType = Promise.resolve(apis.dcm4cheeType());
        const pathRes = Promise.resolve(apis.ctDcm4cheepath());
        const sysRes = Promise.resolve(apis.ctSysConfig());
        Promise.all([resType, pathRes, sysRes]).then(values => {
          userInfo.dcmType = values[0].type;
          userInfo.path = values[1].wado;

          this.props.setCTUserInfo(userInfo);
          this.props.setCurrentCTReportTime(values[2].data);

          this.props.history.push(key);
        });
      } else message.error('您暂未开通此权限，请联系管理员');
    });
  };
  render() {
    const menuList = this.props.userInfo.menus || [];
    let collapsedArr = this.state.menuOpenList;
    const { menuCollapsed } = this.props;
    return (
      <div
        className={`menu-list ${menuCollapsed ? 'closeList' : 'openList'}`}
        style={{ flexBasis: menuCollapsed ? '6%' : '13%' }}
      >
        <div className={menuCollapsed ? 'logo-small' : 'logo-big'}></div>
        <Menu
          defaultSelectedKeys={this.state.selectedKey}
          defaultOpenKeys={collapsedArr}
          openKeys={collapsedArr}
          mode="inline"
          theme="dark"
          inlineCollapsed={menuCollapsed}
          onOpenChange={this.setMenuOpenList}
        >
          {this.getMenuItem(menuList[0].childMenus)}
        </Menu>
      </div>
    );
  }
}

export default withRouter(MenuList);
